module.exports = __webpack_public_path__ + "VIPC4.png?6e92e44d25600265bd21b892fb04d58d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC4.png
// module id = 67
// module chunks = 0